var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.676 0 0 2.676 0 6s2.676 6 6 6 6-2.676 6-6-2.676-6-6-6zm.702 2c.234 0 .43.081.588.243a.8.8 0 0 1 .243.588c0 .23-.08.426-.243.588a.8.8 0 0 1-.588.243.795.795 0 0 1-.582-.243.8.8 0 0 1-.243-.588c0-.23.079-.426.237-.588A.801.801 0 0 1 6.702 2zm.35 2.6v.067l-.019.002-1.14 3.952c-.063.23-.095.38-.095.452 0 .041.017.08.05.118.034.034.07.051.108.051.064 0 .18.007.39-.093.197-.12.626-.383.863-.749l.458.267C7.097 9.658 6.04 10 5.4 10c-.245 0-.705-.068-.852-.204a.703.703 0 0 1-.215-.525c0-.14.032-.317.096-.532l.786-2.702c.076-.26.113-.323.113-.455a.29.29 0 0 0-.107-.22.425.425 0 0 0-.294-.097c-.056 0-.124-.002-.204.002l.077-.334c.746-.101 1.489-.156 2.233-.264l.02-.068z",
    fill: "#8BABFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRounded);
export default __webpack_public_path__ + "static/media/info-rounded.2d1e3f810de05aad9130070653cf5e6f.svg";
export { ForwardRef as ReactComponent };